import * as types from '../actions/types';

const initialState = {
   toggler:false
}

export default function SidebarSettingReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SETTING_TOGLE_SIDEBAR:
            return {
                
                toggler:action.payload,
            } 
        default:
            return state
    }
}
